import { message, fadeOutFlag, fullScreen } from './stores.js'
import { get } from 'svelte/store'

export function changeMessage(msg, fadeOut = true) {
	if (fadeOut) fadeOutFlag.set(true)
	else fadeOutFlag.set(false)
	message.set(msg)
}

export function getRandInt(min, max) {
	// Returns a random integer number between min and max (both included):
	return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getUniqueRandIntegers(howMany, min, max, numberList = []) {
	if (howMany > max - min + 1) {
		console.log('Cannot generate more numbers than the total range')
		return false
	} else {
		let total = howMany - numberList.length
		for (let i = 1; i <= total; i++) {
			let num = getRandInt(min, max)
			while (numberList.includes(num)) {
				num = getRandInt(min, max)
			}
			numberList.push(num)
		}
		return numberList
	}
}

export function shuffle(array) {
	// return an array with randomly ordering the values
	let currentIndex = array.length,
		temporaryValue,
		randomIndex

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex)
		currentIndex -= 1

		// And swap it with the current element.
		temporaryValue = array[currentIndex]
		array[currentIndex] = array[randomIndex]
		array[randomIndex] = temporaryValue
	}

	return array
}

export function separateNumberIntoUnits(n) {
	if (n == 0) return [ 0 ]
	// n = Math.floor(n); // needed for decimal numbers
	let arr = []
	let i = 1

	while (n > 0) {
		arr.unshift((n % 10) * i)
		n = Math.floor(n / 10)
		i *= 10
	}

	return arr
}

export function warning(state, taxi) {
	// do not leave the page by accident
	window.onload = function() {
		window.addEventListener('beforeunload', function(e) {
			// console.log(taxi);
			if (state.finished || taxi === undefined || state.restartClicked) {
				return undefined
			}

			var confirmationMessage =
				'Are you sure you want to exit?' + 'Current progress in the game will be lost will be lost.'

			;(e || window.event).returnValue = confirmationMessage //Gecko + IE
			return confirmationMessage //Gecko + Webkit, Safari, Chrome etc.
		})
	}
}

// export function toggleFullScreen() {
//   if ((document.fullScreenElement && document.fullScreenElement !== null) ||
//    (!document.mozFullScreen && !document.webkitIsFullScreen)) {
//     if (document.documentElement.requestFullScreen) {
//       document.documentElement.requestFullScreen();
//     } else if (document.documentElement.mozRequestFullScreen) {
//       document.documentElement.mozRequestFullScreen();
//     } else if (document.documentElement.webkitRequestFullScreen) {
//       document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
//     }
//   } else {
//     if (document.cancelFullScreen) {
//       document.cancelFullScreen();
//     } else if (document.mozCancelFullScreen) {
//       document.mozCancelFullScreen();
//     } else if (document.webkitCancelFullScreen) {
//       document.webkitCancelFullScreen();
//     }
//   }

//   fullScreen.set(!get(fullScreen))
// }

// export function isFullScreen(){
//   return (document.fullScreenElement && document.fullScreenElement !== null) ||
//   (!document.mozFullScreen && !document.webkitIsFullScreen)
// }
